import { Injectable } from '@angular/core';
import { NucleusWorkflowSecretNotifierContract } from '@nucleus/system-property-ui';
import { BaseComponent } from '@nucleus/ui-base';

/**
 * NUC-382 (mirror of the nucleus-ui-console wiring): bridges the lib's Workflow
 * Secrets notifier contract into BaseComponent's SweetAlert2 snackbar / confirm /
 * access-denied plumbing. Provided at ROOT in app.module.ts (via useClass) so the
 * list screen and its sibling editor route share one instance.
 */
@Injectable()
export class BookwiseWorkflowSecretNotifierAdapter
  extends BaseComponent
  implements NucleusWorkflowSecretNotifierContract {

  success(message: string): void { super.showSuccess(message); }
  error(message: string):   void { super.showError(message); }
  override confirm(title: string, message: string): Promise<boolean> {
    return super.confirm(title, message);
  }
  accessDenied(): void { super.showAccessDeny(); }
}
